import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { PATHS } from 'src/common/constants';
import getClassNames from 'src/common/utils/getClassNames';
import TopDestination from 'src/common/components/TopDestinationOld/index'; // This is still used on /trips
import type { DestinationSimple } from 'src/common/components/TopDestination/index';

import styles from './TopDestinations.module.scss';

export type TopDestinationsProps = {
  destinations: DestinationSimple[];
  classNameModifier?: string;
};

const TopDestinations: FC<TopDestinationsProps> = (
  { destinations, classNameModifier },
) => {
  const [t] = useTranslation('common');

  if (!destinations || destinations.length === 0) {
    return null;
  }
  return (
    <div className={getClassNames(styles, 'root', classNameModifier)}>
      <h4 className={getClassNames(styles, 'heading', classNameModifier)}>
        {t('top-destinations--heading')}
      </h4>
      <ul className={getClassNames(styles, 'list', classNameModifier)}>
        {destinations.map((destination) => (
          <TopDestination
            key={destination.slug}
            destination={destination}
            href={`${PATHS.SEARCH}${destination.slug}`}
          />
        ))}
      </ul>
    </div>
  );
};

export default TopDestinations;
